import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import type { ActivityType } from "../types/activity.types";

const ACTIVITIES_BASE_PATH = "/activities";
const RITUALS_BASE_PATH = "/rituals";

export const getActivityTypeFromPath = (pathname: string): ActivityType =>
  pathname === RITUALS_BASE_PATH || pathname.startsWith(`${RITUALS_BASE_PATH}/`)
    ? "RITUAL"
    : "ACTIVITY";

export const getActivityRoutes = (type?: ActivityType | null) => {
  const base = type === "RITUAL" ? RITUALS_BASE_PATH : ACTIVITIES_BASE_PATH;
  return {
    list: base,
    create: `${base}/new`,
    detail: (id: string) => `${base}/${id}`,
    edit: (id: string) => `${base}/${id}/edit`,
    useModel: (id: string) => `${base}/${id}/use-model`,
  };
};

export const getActivityTypeWording = (type?: ActivityType | null) =>
  type === "RITUAL"
    ? {
        singular: "ritual",
        plural: "rituais",
        singularTitle: "Ritual",
        pluralTitle: "Rituais",
        article: "o",
        ofThe: "do",
        notFound: "não encontrado",
      }
    : {
        singular: "atividade",
        plural: "atividades",
        singularTitle: "Atividade",
        pluralTitle: "Atividades",
        article: "a",
        ofThe: "da",
        notFound: "não encontrada",
      };

export const useActivityRouteType = () => {
  const { pathname } = useLocation();
  return useMemo(() => {
    const activityType = getActivityTypeFromPath(pathname);
    return { activityType, routes: getActivityRoutes(activityType) };
  }, [pathname]);
};
